import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import account from '@/store/modules/account';
import yields from '@/store/modules/yields';
import profile from '@/store/modules/profile';
import { module as cache } from '@/plugins/cache';
import bind from '@/store/plugins/bind';
import queue from '@/store/plugins/queue';
import axios from '@/store/plugins/axios';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    axiosVariables: {
      baseUrl: '',
    },
  },
  plugins: [
    bind({ params: () => store.$api }),
    queue,
    axios(() => ({
      baseURL: store.state.axiosVariables.baseUrl,
      apiVersion: '1.0',
      token: store.state.account.userToken || store.state.account.tokens.access_token,
      locale: 'nl',
    })),
    createPersistedState({ key: 'vuex.mysolarpanels', paths: ['account'] }),
  ],
  mutations: {
    ['inject-axios-variables'](state, { baseUrl }) {
      console.log(baseUrl);
      state.axiosVariables.baseUrl = baseUrl;
    },
  },
  actions: {},
  modules: {
    cache,
    account,
    yields,
    profile,
  },
});

export default store;
